/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoTransazioneVoucher } from './tipo-transazione-voucher';


export interface TransazioneVoucherBackofficeListItemDTO { 
    id_transazione?: string;
    data?: string;
    tipo_transazione?: TipoTransazioneVoucher;
    valore_transazione?: number;
    valore_scontrino?: number;
    numero_scontrino?: string;
    codice_voucher?: string;
    intestatario?: string;
    nome_negozio?: string;
    version_voucher?: number;
}



